/* Hook encargado de crear o modificar el perfil de un usuario

Autor: Benjamín León
Fecha: 2024-12-15
*/
import { useState } from 'react'

import { makeUrlUserPasswordReq } from '@/hooks/connectionData.tsx'

const useUserPasswordReq = () => {
  const [errorUserPasswordReq, setErrorUserPasswordReq] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  // Crea o modifica
  const userPasswordReq = async (email: string) => {
    setLoading(true)

    try {
      const res = await fetchDatabase(email)
      setErrorUserPasswordReq(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorUserPasswordReq(err)
      } else {
        setErrorUserPasswordReq(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Llamamos sin autentificacion
  const fetchDatabase = async (email: string): Promise<string> => {
    const apiUrl = makeUrlUserPasswordReq()

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: email }), // Assuming vehicle.id is available
    })

    if (!response.ok) {
      const errorData = await response.json() // Parse JSON error response
      throw new Error(errorData.error || response.statusText)
    }

    const msg = await response.json()

    return msg
  }

  // Exponemos estas variables al exterior
  return { errorUserPasswordReq, loading, userPasswordReq }
}
export default useUserPasswordReq
